import {put, takeLatest, call} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import {get} from 'lodash';
import {
  fetchCorporateRequestsRequest,
  fetchCorporateRequestsSuccess,
  fetchCorporateRequestsError,
  updateCorporateRequestRequest,
  updateCorporateRequestSuccess,
  updateCorporateRequestError,
} from './index';
import {fetchCorporateRequests, updateCorporateRequest} from './api';

export const sagaActions = {
  FETCH_CORPORATE_REQUESTS: 'FETCH_CORPORATE_REQUESTS',
  UPDATE_CORPORATE_REQUEST: 'UPDATE_CORPORATE_REQUEST',
};

function* fetchCorporateRequestsSaga({payload}) {
  const {values} = payload;
  try {
    yield put(fetchCorporateRequestsRequest());
    const result = yield call(fetchCorporateRequests, values);
    if (!result.error) {
      yield put(
        fetchCorporateRequestsSuccess({
          data: result.data,
          page: values.page,
          pageSize: values.pageSize,
          totalPages: result.data.totalPages,
          totalRecords: result.data.totalRecords,
          sortOn: values.sortOn,
          sortDir: values.sortDir,
          filter: {...values.filter},
        })
      );
    } else {
      yield put(fetchCorporateRequestsSuccess([]));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchCorporateRequestsError(message));
    } else {
      toast.error(e.error);
      yield put(fetchCorporateRequestsError(e.error));
    }
  }
}

function* updateCorporateRequestSaga({payload}) {
  const {values} = payload;
  try {
    yield put(updateCorporateRequestRequest());
    const result = yield call(updateCorporateRequest, values);
    if (!result.error) {
      toast.success(result.message);
      yield put(updateCorporateRequestSuccess(result.data));
    } else {
      toast.error(result.message);
      yield put(updateCorporateRequestError(result.message));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(updateCorporateRequestError(message));
    } else {
      toast.error(e.error);
      yield put(fetchCorporateRequestsError(e.error));
    }
  }
}

function* rootSagas() {
  yield takeLatest(
    sagaActions.FETCH_CORPORATE_REQUESTS,
    fetchCorporateRequestsSaga
  );
  yield takeLatest(
    sagaActions.UPDATE_CORPORATE_REQUEST,
    updateCorporateRequestSaga
  );
}

export default rootSagas;
